// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2mTRY","info":"PatientInfo_info__QsGpJ"};